import Root, { FrontierBaseProviders } from '@fs/zion-root'
import '@fs/react-scripts/polyfills'
import { Router } from '@fs/zion-router'
import { AppLayout, LayoutBand } from '@fs/zion-ui'
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { NoticeLoading } from '@fs/zion-icon'
import * as Sentry from '@sentry/browser'
import { sentryDSN, mergeSentryConfig } from '@fs/zion-config'
import App from './components/App'
import './locales'
import * as serviceWorker from './serviceWorker'
import { describeUiBreadcrumb } from './util/SentryBreadcrumbUtil'
import sentryIgnoredErrors from './util/sentryIgnoredErrors'

if (sentryDSN) {
  Sentry.init(
    mergeSentryConfig({
      dsn: sentryDSN,
      beforeBreadcrumb: describeUiBreadcrumb,
      // Suppression filter for non-actionable, out-of-our-control errors. mergeSentryConfig
      // concatenates this onto the org-wide ignoreErrors defaults. Add new patterns in
      // ./util/sentryIgnoredErrors.js rather than here.
      ignoreErrors: sentryIgnoredErrors,
    })
  )
}

// Enable local feature flag development using the file "dev.flags.js"
// If that file exports anything truthy it will initialize feature flags in localhost mode
// and use the flags defined in that file, instead of flags defined in split.
const mockFlags = process.env.NODE_ENV === 'development' ? import('./dev.flags').then((m) => m.default) : undefined
const mockActivities =
  process.env.NODE_ENV === 'development' ? import('./dev.activities').then((m) => m.default) : undefined

const base = window.SERVER_DATA ? new URL(window.SERVER_DATA.appPath).pathname : ''

// Add any app logic here as flags, languages and translations are now configured and available
const FrontierWrapper = () => {
  return (
    <Router basename={base}>
      <Root analytics helpChatbot={false}>
        <AppLayout fullWidth>
          <LayoutBand maxWidth="xl">
            <App />
          </LayoutBand>
        </AppLayout>
      </Root>
    </Router>
  )
}

// Do not make changes to FrontierRoot, all changes should be made to FrontierWrapper
const FrontierRoot = () => (
  <React.StrictMode>
    <Suspense fallback={<NoticeLoading />}>
      <FrontierBaseProviders mockFlags={mockFlags} mockActivities={mockActivities}>
        <FrontierWrapper />
      </FrontierBaseProviders>
    </Suspense>
  </React.StrictMode>
)

ReactDOM.render(<FrontierRoot />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
